interface HighlightedTextProps {
  text: string
  terms: string[]
}

function escapeRegularExpression(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function HighlightedText({ text, terms }: HighlightedTextProps) {
  const usefulTerms = terms.filter((term) => term.length > 0)
  if (usefulTerms.length === 0) return text

  const expression = new RegExp(`(${usefulTerms.map(escapeRegularExpression).join('|')})`, 'gi')
  return text.split(expression).map((part, index) =>
    usefulTerms.some((term) => term.toLowerCase() === part.toLowerCase()) ? (
      <mark key={`${part}-${index}`}>{part}</mark>
    ) : (
      part
    ),
  )
}

